export default function getMyUpsolveEntryUrl(fromStudentLoansCTA: boolean = false): string {
  if (!UPSOLVE_FILER_URL) return "";

  // Base URL
  const url = new URL(`${UPSOLVE_FILER_URL}/bankruptcy-screener`);

  // Pass the fromStudentLoansCTA flag to the screener
  if (fromStudentLoansCTA) url.searchParams.set("fromStudentLoansCTA", "true");

  // Carry over any UTM parameters that are present on the current page
  if (typeof window !== "undefined") {
    const currentParams = new URLSearchParams(window.location.search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((key) => {
      const val = currentParams.get(key);
      if (val) url.searchParams.set(key, val);
    });
  }

  return url.toString();
}
